<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de pagos/abonos a facturas entrantes</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="save_dialog = true"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Registrar abono</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="Pagos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1 mt-5"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            @click:row="
                (item) => {
                    editAbono(item);
                }
            "
            :item-class="
                () => {
                    return 'pointer';
                }
            "
            :server-items-length="totalPagos"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>

            <template v-slot:item.proveedor="{ item }">
                <span>{{ item.proveedor.nombre }}</span>
            </template>

            <template v-slot:item.factura="{ item }">
                <span>{{ item.factura ? item.factura.id : "" }}</span>
            </template>

            <template v-slot:item.importe="{ item }">
                {{ formatPrice(item.importe) }}€
            </template>

            <template v-slot:item.albaranes="{ item }">
                <template v-if="item.factura != null">
                    <span
                        v-for="albaran in item.factura.albaranes"
                        :key="albaran.id"
                        >{{ albaran.nro }},
                    </span>
                </template>
            </template>

            <template v-slot:item.action="{ item }">
                <!--router-link
                    :to="{ path: `/guardar-proveedor?id=${item.id}` }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </~router-link-->
                <a @click.stop="openModal(item)">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="pointer-events: none; font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>

        <!-- Modal para crear abono -->
        <v-dialog v-model="save_dialog" max-width="600px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar abono
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row class="mt-3">
                        <v-col cols="12" md="6">
                            <dynamicSelectVue
                                ref="dynamicSelectProveedor"
                                title="Proveedor"
                                :value="abono.id_proveedor"
                                max-width="800px"
                                outlined
                                @create="saveProveedor"
                                @delete="deleteProveedor"
                                @getEstado="getProveedorId"
                                @update="saveProveedor"
                                @changeElement="changeProveedor"
                            >
                                <v-form
                                    ref="formProveedor"
                                    v-model="validFormProveedor"
                                >
                                    <v-row class="mt-3">
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.nombre"
                                                label="Nombre"
                                                :rules="[rules.required]"
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                outlined
                                                v-model="
                                                    proveedor.nombre_fiscal
                                                "
                                                label="Nombre fiscal"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.cif"
                                                label="CIF"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.email"
                                                label="Email"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.telefono"
                                                label="Teléfono"
                                                required
                                                :rules="[rules.phone_rule]"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="8">
                                            <v-text-field
                                                outlined
                                                label="Dirección"
                                                v-model="proveedor.direccion"
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.cp"
                                                label="CP"
                                                required
                                                :rules="[rules.number_rule]"
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.poblacion"
                                                label="Población"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-autocomplete
                                                outlined
                                                v-model="proveedor.provincia"
                                                label="Provincia"
                                                required
                                                :items="provincias"
                                                item-text="nombre"
                                                item-value="nombre"
                                                dense
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                outlined
                                                v-model="proveedor.pais"
                                                label="País"
                                                required
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="12">
                                            <v-textarea
                                                outlined
                                                v-model="
                                                    proveedor.observaciones
                                                "
                                                label="Observaciones"
                                                dense
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </dynamicSelectVue>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="abono.id_factura"
                                label="Seleccionar factura"
                                :items="facturas"
                                item-text="nro"
                                item-value="id"
                                @change="facturaSelected"
                                outlined
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <date-select
                                v-model="abono.fecha"
                                label="Fecha"
                                outlined
                            >
                            </date-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="abono.importe"
                                type="number"
                                label="Importe"
                                outlined
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            save_dialog = false;
                            selectedItem = {};
                            clearAbono();
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="SaveAbono()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal para eliminar abono -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deletePago()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";
import proveedoresSelectVue from "../../../components/general/proveedoresSelect.vue";
import dynamicSelectVue from "../../../components/general/dynamicSelect.vue";
import { rules } from "../../../rules";
import { formatPrice } from "../../../helpers";

export default {
    components: {
        proveedoresSelectVue,
        dynamicSelectVue,
    },
    data() {
        return {
            validFormProveedor: true,
            rules: rules,
            totalPagos: 0,
            cantidad: 15,
            page: 1,
            search: "",
            headers: [
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Proveedor", value: "proveedor", sortable: false },
                { text: "Factura", value: "factura", sortable: false },
                {
                    text: "Albaranes asociados",
                    value: "albaranes",
                    sortable: false,
                },
                { text: "Importe", value: "importe", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            Pagos: [],
            abono: {
                id_factura: "",
                id_proveedor: "",
                fecha: "",
                importe: "",
            },
            Proveedores: [],
            facturas: [],
            selectedId: 0,
            dialog: false,
            save_dialog: false,

            proveedor: {
                id: null,
                nombre: "",
                nombre_fiscal: "",
                cif: "",
                telefono: "",
                direccion: "",
                cp: "",
                poblacion: "",
                provincia: "",
                pais: "",
                observaciones: "",
                email: "",
            },
        };
    },
    created() {
        this.getPagos();
        // this.getProveedores();
        this.getFacturas();
        this.$store.dispatch("getProvincias", this);
    },
    methods: {
        ChangeSize(event) {
            this.cantidad = event;
            this.getPagos();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getPagos();
        },
        getFacturas() {
            if (this.abono.id_proveedor != null) {
                axios
                    .get(
                        `api/get-facturas-entrantes?id_proveedor=${this.abono.id_proveedor}`
                    )
                    .then(
                        (res) => {
                            //console.log(res.data.users);
                            this.facturas = res.data.data;
                            //console.log(this.Pagos);
                        },
                        (err) => {
                            this.$custom_error(
                                "Error consultando el proveedor"
                            );
                        }
                    );
            }
        },

        facturaSelected(id) {
            let factura_selected = this.facturas.find(
                (element) => element.id === id
            );

            this.abono.id_proveedor = factura_selected.id_proveedor;
        },

        getPagos() {
            axios
                .get(
                    `api/get-abonos-entrante?page=${this.page}&amount=${this.cantidad}&busqueda=${this.search}`
                )
                .then(
                    (res) => {
                        //console.log(res.data.users);
                        this.Pagos = res.data.abonos.data;
                        this.totalPagos = res.data.abonos.total;
                        //console.log(this.Pagos);
                    },
                    (err) => {
                        this.$custom_error("Error consultando los abonos");
                    }
                );
        },
        openModal(item) {
            this.selectedId = item.id;
            this.dialog = true;
        },
        deletePago() {
            axios.delete(`api/delete-abono-entrante/${this.selectedId}`).then(
                (res) => {
                    this.$toast.sucs("Abono eliminado con éxito");
                    this.dialog = false;
                    this.getPagos();
                    this.clearAbono();
                },
                (err) => {
                    this.$custom_error("Error eliminando el abono");
                }
            );
        },
        SaveAbono() {
            axios.post("api/save-abono-entrante", this.abono).then(
                (res) => {
                    this.$toast.sucs("Abono guardado con éxito");
                    this.save_dialog = false;
                    this.getPagos();
                    this.clearAbono();
                },
                (err) => {
                    this.$custom_error("Error guardando el abono");
                }
            );

            this.getPagos();
        },
        editAbono(item) {
            this.abono = { ...item };
            this.save_dialog = true;
        },
        clearAbono() {
            this.abono = {
                id_factura: "",
                id_proveedor: "",
                fecha: "",
                importe: "",
            };
        },

        // Funciones de dynamicSelect proveedor
        saveProveedor() {
            this.$refs.formProveedor.validate();
            if (!this.validFormProveedor) return;
            axios
                .post("api/save-proveedor", this.proveedor)
                .then((res) => {
                    this.$refs.dynamicSelectProveedor.closeDialog();
                    this.$toast.sucs("Proveedor guardado con éxito");
                    this.clearProveedor();
                    this.$store.dispatch("getProveedores", this);
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        deleteProveedor(id) {
            axios
                .post(`api/delete-proveedor`, { id: id })
                .then((res) => {
                    this.$toast.sucs("Proveedor eliminado con éxito");
                    this.$store.dispatch("getProveedores", this);
                    this.clearProveedor();
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        getProveedorId(id) {
            if (id != null) {
                axios
                    .get(`api/getproveedor/${id}`)
                    .then((res) => {
                        this.proveedor = res.data;
                    })
                    .catch((error) => {
                        if (error.response.code == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Error procesando la solicitud");
                        }
                    });
            }
        },
        changeProveedor(id) {
            this.abono.id_proveedor = id;
            this.getFacturas();
        },
        clearProveedor() {
            this.proveedor = {
                id: null,
                nombre: "",
                nombre_fiscal: "",
                cif: "",
                telefono: "",
                direccion: "",
                cp: "",
                poblacion: "",
                provincia: "",
                pais: "",
                observaciones: "",
                email: "",
            };
        },

        formatPrice,

        // En desuso
        /*getProveedores() {
            axios.get(`api/get-proveedores`).then(
                (res) => {
                    //console.log(res.data.users);
                    this.Proveedores = res.data.data;
                    this.total_cliente = res.data.total;
                    //console.log(this.Proveedores);
                },
                (err) => {
                    this.$custom_error("Error consultando los proveedores");
                }
            );
        },*/
    },
    watch: {
        search: debounce(function (val) {
            this.getPagos();
        }, 500),
        /*"abono.id_proveedor"(val) {
            this.getFacturas();
        },*/
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
        provincias() {
            const data = this.$store.getters.getprovincias;
            return data;
        },
    },
};
</script>
